module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/2/1-c75f51c2acb5e01a97ebc6f488ab7047.png";